import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logoImg from "images/logo.svg";
import logoLightImg from "images/logo-light.svg";
import Cookies from "js-cookie";
import { useOnlineOrderSettings } from "contaxt/OnlineOrderSettingsContext";
export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
  className = "flex-shrink-0",
}) => {
  const { settings, isLoading } = useOnlineOrderSettings();
  const merchantName = Cookies.get("merchantname");


  return (
    <Link
      to={`/${merchantName}`}
      className={`ttnc-logo inline-block text-slate-600 ${className}`}
    >
      {!isLoading && settings?.logo ? (
        <img
          className="block max-h-16 sm:max-h-14 dark:text-gray-100 rounded-lg"
          src={settings?.logo}
          alt="Logo"
        />
      ) : (
        "Logo Here"
      )}
    </Link>
  );
};

export default Logo;
